/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:04dc800f-84e8-4195-a637-e47b587a593d",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_zK4eO1aOG",
    "aws_user_pools_web_client_id": "a62s1nv48b03vvsme9hbf9ibp",
    "sso_auth_key": "",
    "oauth": {},
    "aws_content_delivery_bucket": "worldpay-prd-eu-west-1-website",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://worldpay-prd.merchant-dispute.com"
};


export default awsmobile;
